import {
  Box,
  TextField,
  InputAdornment,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";

function SearchBar({ search, setSearch }) {
  return (
    <Box
      sx={{
        maxWidth: 700,
        mx: "auto",
        mb: 5,
      }}
    >
      <TextField
        fullWidth
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search by Common Name, Scientific Name, Family..."
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="success" />
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: 10,
            bgcolor: "#fff",
            boxShadow: "0 10px 25px rgba(0,0,0,.08)",
          },
        }}
      />
    </Box>
  );
}

export default SearchBar;